export enum PageType {
  StartPage = 'Start',
  MeteringPointDetailsHaveFunctionProtocol = 'Anläggningsdetalj - har funktionskontroll',
  MeteringPointDetailsDontHaveFunctionProtocol = 'Anläggningsdetalj - har inte funktionskontroll',
  ContractPage = 'Avtalstext',
  FocusPage = 'I fokus'
}
